import { html } from 'lit';
const Telegram =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.93 4.929A9.999 9.999 0 1 1 19.07 19.07 9.999 9.999 0 1 1 4.93 4.93m7.428 4.454q-1.458.606-5.831 2.511-.711.283-.744.553c-.039.304.342.424.86.587l.22.07c.51.166 1.198.36 1.554.368q.487.01 1.085-.4 4.087-2.76 4.218-2.789c.063-.014.149-.032.207.02.06.052.053.15.047.177-.037.16-1.527 1.546-2.303 2.267-.244.227-.417.388-.452.424a9 9 0 0 1-.236.233c-.474.457-.83.8.02 1.36.412.271.741.495 1.07.72.353.24.706.48 1.162.78q.175.116.338.233c.414.296.786.56 1.246.518.267-.024.544-.275.683-1.025.33-1.77.982-5.608 1.132-7.19a1.8 1.8 0 0 0-.015-.393.43.43 0 0 0-.142-.27c-.12-.098-.305-.118-.388-.117-.376.007-.953.207-3.731 1.363" clip-rule="evenodd"/>
  </svg>
`;
export default Telegram;
